import Icon from '@/components/UI/Icon';
import { _isEmpty, _notNil } from '@/littledash';
import type { Animal } from '@/model/Animal.model';
import { DateUtils } from '@/utils/Date.utils';
import type { FC } from 'react';

interface AnimalMetaProps {
  animal: Animal;
  closeModal: () => void;
}

interface SectionProps {
  title: string;
  value: string;
  key: string | number;
}

const Section: FC<SectionProps> = ({ title, value, key }) => (
  <div key={key} className="bb b--moon-gray pa3 f6 break-word">
    <h4 className="basier-med lh-solid normal">{title}</h4>
    <p className="mt1 basier-reg normal lh-copy dark-gray">{value}</p>
  </div>
);

export const AnimalMeta: FC<AnimalMetaProps> = ({ animal, closeModal }) => {
  const metadata = animal.metadata ?? [];

  const renderValue = (value: string, field_type: string) => {
    if (_notNil(value)) {
      if (Array.isArray(value)) {
        return _isEmpty(value) ? '-' : value.join(', ');
      }
      if (field_type === 'date') {
        return DateUtils.renderDate(value, { defaultResponse: '-' });
      }
      return value;
    }
    return '-';
  };

  return (
    <div className="ui-card center" style={{ width: '400px' }}>
      <div className="pa3 relative">
        <div className={'f5 ui__group-label relative w-100 pr3 black'}>
          <div className="lh-title">{animal.name}</div>
        </div>
        <a onClick={closeModal} className="absolute right-0 top-0 ma2 w2 h2 pointer flex hover-near-black">
          <Icon icon="close" width="12" height="12" className="self-center center" />
        </a>
      </div>
      {metadata.map(({ title, value, field_type }, index) => (
        <Section key={index} title={title} value={renderValue(value, field_type)} />
      ))}
    </div>
  );
};
